import React from 'react'
import { Link } from 'react-router-dom'

function Footer() {
    return (
        <>
            <footer className="footer-bg footer-p">
                <div className="footer-top  pt-120 pb-90" style={{ backgroundColor: "#000" }}>
                    <div className="container">
                        <div className="row justify-content-between">
                            <div className="col-xl-4 col-lg-4 col-sm-6">
                                <div className="footer-widget mb-30">
                                    <div className="f-info">
                                        <h2>Let's discuss your projects now</h2>
                                        <p>Contact us to give life to awesome ideas or make suggestions on improvements to be made. </p>
                                        <div className="footer-social">
                                            <Link to="#">
                                                <i className="fab fa-facebook-f" />
                                            </Link>
                                            <Link to="#">
                                                <i className="fab fa-twitter" />
                                            </Link>
                                            <Link to="#">
                                                <i className="fab fa-instagram" />
                                            </Link>
                                            <Link to="#">
                                                <i className="fab fa-youtube" />
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-3 col-sm-6">
                                <div className="footer-widget mb-30">
                                    <div className="footer-link footer-link2">
                                        <ul>
                                            <li>
                                                <Link to="/about"> <i className="fas fa-long-arrow-right" /> About Us </Link>
                                            </li>
                                            <li>
                                                <Link to="/"> <i className="fas fa-long-arrow-right" /> Our Services </Link>
                                            </li>
                                            <li>
                                                <Link to="#"> <i className="fas fa-long-arrow-right" /> Projects{" "}  </Link>
                                            </li>
                                            <li>
                                                <Link to="/contact"> <i className="fas fa-long-arrow-right" /> Get In Touch  </Link>
                                            </li>
                                            <li>
                                                <Link to="/contact"> <i className="fas fa-long-arrow-right" /> Faq Page </Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-5 col-lg-5 col-sm-6">
                                <div className="footer-widget mb-30">
                                    <form action="mail.php" method="post" className="contact-form fcontact" >
                                        <div className="row">
                                            <div className="col-lg-12">
                                                <div className="contact-field p-relative c-name mb-20">
                                                    <input type="text" id="firstn" name="firstn" placeholder="Your name **" required="" />
                                                </div>
                                            </div>
                                            <div className="col-lg-12">
                                                <div className="contact-field p-relative c-subject mb-20">
                                                    <input type="text" id="email" name="email" placeholder="Business email **" required="" />
                                                </div>
                                            </div>
                                            <div className="col-lg-12">
                                                <div className="contact-field p-relative c-message mb-30">
                                                    <textarea name="message" id="message" cols={30} rows={10} placeholder="Message **" defaultValue={""} />
                                                </div>
                                                <div className="slider-btn">
                                                    <button className="btn ss-btn active" data-animation="fadeInRight" data-delay=".8s" >
                                                        <span>
                                                            <i className="fas fa-angle-right" /> Submit Now
                                                        </span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="copyright-wrap">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-12 text-center">
                                Copyright &amp; design By <Link to="#">@ZcubeDesign</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )
}

export default Footer